import { Component, OnInit, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { CategoryService } from '../_services/category.service';
import { Category } from './category.model';
import { Products } from './products.model';
import { ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { appsettings } from '../shared/app.settings';
import { DayPickerComponent } from 'ngx-foundation';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit, AfterViewInit {

  @ViewChildren('featureList') featureListElement: QueryList<any>;
  link: string;
  id: number;
  country: string;
  language: string;

  categoryName: string;
  product: any;

    categories: Category[] = [];
  excepts: any;
  products: Products[] = [];
  child: any;
  open: string;

  fragment: string;
  // product: {id: number, link: string};

  constructor(
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router, 
    private titleService: Title,
  ) { }


  setAllCategory(link: string, country: string, language: string) {
    this.categoryService.getCategory(link, country, language)
      .subscribe(
        resultArray => {
            this.categories = resultArray['categories'];
            this.excepts = resultArray['excepts'];
            this.products = resultArray['products'];
            
            console.log(this.products);
          this.categoryName = this.categories[0].name;
          return this.titleService.setTitle(this.categoryName + ' | ' + appsettings.siteTitle);
        },
        error => console.log('Error ::' + error)
      );
  }

  ngOnInit(): void {
   

    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });

    this.route.params
      .subscribe(
        (params: Params) => {
          this.link = params['link'];
          this.country = params['country'];
          this.language = params['language'];
          this.setAllCategory(this.link, this.country, this.language);
        }
      );
  }

  openModal() {
      this.open = 'block';
  }

  closeModal() {
    this.open = 'none';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      $(document).foundation();
    }, 1000);
    if (this.fragment && this.fragment != "") {
      this.featureListElement.changes.subscribe(t => {
        $('#' + this.fragment).get(0).scrollIntoView();
      })
      // setTimeout(() => {
      //   $('#' + this.fragment).get(0).scrollIntoView();
      // }, 4000);
      // $('#' + this.fragment).get(0).scrollIntoView();
      // let element = document.querySelector('#' + this.fragment);
      // console.log(this.fragment);
      // console.log(element);
      // if(element) {
      //   element.scrollIntoView();
      // }
    }
  }

}
